import React, { Component, useCallback, useRef } from 'react';
import visitingprogram from '../../../services/visitingprogram';
import captchaService from '../../../services/captcha';
import { Button, Input, Screen, Text, SubHeader } from '../../../components';
import { maskPhone } from '../../../utils/helpers';
import ReCAPTCHA from 'react-google-recaptcha';

import PropTypes from 'prop-types';
import {
  ContactContainer,
  ColStyled,
  ButtonContainer,
  Textsbody,
  Textslist,
  RowStyled,
  H2Typography,
  Programsimg,
} from './styles';

import banner from '../../../assets/imgs/banner-desktop-visiting-program.webp';
import bannerMobile from '../../../assets/imgs/banner-mobile-visiting-program.webp';
import portas from '../../../assets/logos/logo-portas-abertas.png';

const {
  defaultStates,
  defaultAlertScreenOnClick,
  defaultModalOnHide,
} = require('../../../utils/defaults');

class VisitingProgram extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contact: {
        name: '',
        email: '',
        phone: '',
        participants: '',
        cooperative: '',
        message: '',
      },
      labelButton: 'Enviar',
      success: false,
      error: false,
      recaptcha: false,
      ...defaultStates(),
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.modalOnHide = this.modalOnHide.bind(this);
    this.alertScreenOnClick = this.alertScreenOnClick.bind(this);
    this.header = this.header.bind(this);
    this.body = this.body.bind(this);
  }

  modalOnHide = () => {
    defaultModalOnHide(this);
  };

  alertScreenOnClick = () => {
    defaultAlertScreenOnClick(this);
  };

  handleSubmit = async () => {
    this.setState({ loadingState: true });
    const { contact } = this.state;
    const { recaptcha } = this.state;
    let labelButton = '';
    let success = false;
    let error = false;

    if (recaptcha) {
      const response = await visitingprogram.save(contact);
      if (response.ok) {
        const alertScreenState = {
          title: 'Mensagem enviada com sucesso!',
          open: true,
          onClick: this.alertScreenOnClick,
          pagePath: '/programa-fgcoop-portas-abertas',
        };
        labelButton = 'Enviada!';
        success = true;

        this.setState({ alertScreenState, labelButton, success, error });
      } else {
        const modalState = {
          title: 'Erro',
          text: response.message,
          toggle: true,
          onHide: this.modalOnHide,
        };
        labelButton = 'Erro';
        error = true;

        this.setState({ modalState, labelButton, success, error });
      }
    } else {
      const modalState = {
        title: 'Erro',
        text: 'reCAPTCHA não foi verificado!',
        toggle: true,
        onHide: this.modalOnHide,
      };
      labelButton = 'Erro';
      error = true;
      this.setState({ modalState, labelButton, success, error });
    }
    this.setState({ loadingState: false });
  };

  handleChange = (field, event) => {
    const { contact } = this.state;

    const value = event.target
      ? field === 'phone'
        ? maskPhone(event.target.value)
        : event.target.value
      : event;

    contact[field] = value;
    this.setState({ contact });
  };

  handleChangeCaptcha = async (token) => {
    const response = await captchaService.checkCaptcha(token);
    if (response.data.success === true) {
      this.setState({ recaptcha: true });
    } else {
      this.setState({ recaptcha: false });
    }
  };

  header() {
    return (
      <SubHeader
        image
        backgroundImage={banner}
        backgroundImageMobile={bannerMobile}
        minHeightSm={452}
        minHeight={313}
        title={'Programa Portas Abertas'}
      />
    );
  }

  body = () => {
    const { contact, success, error, labelButton, recaptcha } = this.state;

    return (
      <ContactContainer className={'mb-lg-5 pb-lg-5'}>
        <RowStyled className={'mb-lg-5 d-flex flex-wrap justify-content-center'}>
          <ColStyled lg={6} className="order-1 order-lg-1">
            <Textsbody>
              Já imaginou conhecer de perto como o FGCoop atua para fortalecer o cooperativismo de
              crédito e proteger os depósitos dos cooperados? <br />
              <br />O Programa FGCoop Portas Abertas foi criado especialmente para as lideranças do
              cooperativismo de crédito. A iniciativa proporciona uma oportunidade de conhecer
              melhor o funcionamento do Fundo, suas operações e o papel que desempenha na proteção
              dos depósitos e no fortalecimento da solidez do Sistema Nacional de Crédito
              Cooperativo (SNCC)
            </Textsbody>
          </ColStyled>

          <ColStyled lg={12} className="order-2 order-lg-3">
            <Textsbody className={'mt-0'}>
              As cooperativas podem participar de duas formas: por meio de visitas presenciais à
              sede do FGCoop, em Brasília (DF), ou de encontros online, que ampliam o acesso ao
              programa e possibilitam a participação de lideranças e representantes de cooperativas
              de todo o país, sem a necessidade de deslocamento.
              <br />
              <br />
              Durante a experiência, os participantes têm contato com a atuação institucional do
              FGCoop, conhecem suas principais frentes de trabalho e podem esclarecer dúvidas sobre
              o funcionamento do Fundo e sua contribuição para a segurança e a estabilidade do
              cooperativismo de crédito.
            </Textsbody>
          </ColStyled>

          <ColStyled lg={6} className={'d-flex justify-content-center order-3 order-lg-2'}>
            <Programsimg src={portas}></Programsimg>
          </ColStyled>
        </RowStyled>

        <RowStyled className={'mb-lg-2'}>
          <H2Typography>Como participar</H2Typography>

          <ColStyled lg={12}>
            <Textsbody>
              Para solicitar a participação no Programa FGCoop Portas Abertas, basta preencher o
              formulário abaixo e indicar a modalidade de interesse: presencial ou online. Após o
              envio das informações, a equipe de Comunicação do FGCoop entrará em contato para
              alinhar os detalhes, a agenda e o formato do encontro.
            </Textsbody>
          </ColStyled>
        </RowStyled>

        <RowStyled className={'mb-lg-2'}>
          <H2Typography>Informações importantes</H2Typography>
          <Textslist>
            <li>
              As visitas presenciais são destinadas prioritariamente a lideranças e representantes
              das cooperativas de crédito.
            </li>
            <li>
              As visitas presenciais acontecem entre 10h e 16h e têm duração de até três horas.
            </li>
            <li>
              Os encontros online podem ser agendados conforme a disponibilidade da cooperativa e da
              equipe do FGCoop.
            </li>
            <li>
              A modalidade online permite a participação de cooperativas de diferentes regiões do
              país, sem necessidade de deslocamento até Brasília.
            </li>
            <li>
              Hospedagem e deslocamento até a sede do FGCoop são de responsabilidade dos visitantes.
            </li>
            <li>É permitido tirar fotos durante a visita presencial, exceto em áreas restritas.</li>
          </Textslist>
          <ColStyled lg={8}>
            <Textsbody>
              <b>Esperamos você para conhecer mais de perto o nosso trabalho!</b>
            </Textsbody>
          </ColStyled>
        </RowStyled>

        <RowStyled className={'mb-lg-5 pb-lg-5 d-flex flex-column align-items-center'}>
          <H2Typography>Preencha o formulário com sua solicitação de visita</H2Typography>
          <ColStyled
            lg={8}
            className={'d-flex flex-column justify-content-center mb-4 pb-3 mb-lg-0 pb-lg-0'}>
            <Input
              rounded
              border
              required
              id={'name'}
              value={contact.name}
              placeholder={'NOME'}
              fontSize={14}
              maxLength={255}
              width={730}
              height={48}
              onChange={(e) => {
                this.handleChange('name', e);
              }}
              error={error && contact.name === ''}
            />
            <Input
              rounded
              border
              required
              id={'email'}
              type={'email'}
              value={contact.email}
              placeholder={'E-MAIL'}
              fontSize={14}
              maxLength={255}
              width={730}
              height={48}
              onChange={(e) => {
                this.handleChange('email', e);
              }}
              error={error && contact.email === ''}
            />
            <Input
              rounded
              border
              required
              id={'phone'}
              value={contact.phone}
              placeholder={'TELEFONE'}
              fontSize={14}
              maxLength={15}
              width={730}
              height={48}
              onChange={(e) => {
                this.handleChange('phone', e);
              }}
              error={error && contact.phone === ''}
            />
            <Input
              rounded
              border
              required
              id={'participants'}
              value={contact.participants}
              placeholder={'QUANTIDADE DE PARTICIPANTES'}
              fontSize={14}
              maxLength={255}
              width={730}
              height={48}
              onChange={(e) => {
                this.handleChange('participants', e);
              }}
              error={error && contact.participants === ''}
            />
            <Input
              rounded
              border
              required
              id={'cooperative'}
              value={contact.cooperative}
              placeholder={'COOPERATIVA'}
              fontSize={14}
              maxLength={255}
              width={730}
              height={48}
              onChange={(e) => {
                this.handleChange('cooperative', e);
              }}
              error={error && contact.cooperative === ''}
            />
            <Input
              rounded
              border
              required
              textarea
              id={'message'}
              value={contact.message}
              placeholder={'MENSAGEM'}
              fontSize={14}
              width={730}
              height={48}
              onChange={(e) => {
                this.handleChange('message', e);
              }}
              error={error && contact.message === ''}
            />

            <ReCAPTCHA
              sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
              onChange={(e) => {
                this.handleChangeCaptcha(e);
              }}
            />

            <ButtonContainer>
              <Button
                greenButton
                width={113}
                widthMobile={150}
                text={labelButton}
                onClick={() => {
                  this.handleSubmit();
                }}
                success={success}
                error={error}
              />
            </ButtonContainer>
          </ColStyled>
        </RowStyled>
      </ContactContainer>
    );
  };

  render = () => {
    const { modalState, alertScreenState, loadingState } = this.state;

    return (
      <Screen
        header={this.header}
        body={this.body}
        modalState={modalState}
        alertScreenState={alertScreenState}
        loadingState={loadingState}
      />
    );
  };
}

VisitingProgram.propTypes = {
  //props
  history: PropTypes.object,
};
export default VisitingProgram;
